import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom'

import { SettingsContext } from '../contexts/index.jsx'

const TopNav = ({ items }) => {
  const location  = useLocation();
  const settings = useContext(SettingsContext);

  const navItems = items.map(item => {
    const active = item.active || item.to.indexOf(location.pathname) === 0;

    return (
      <div key={item.label} className={`${active ? 'active' : ''}`}>
        <Link to={{
          pathname: item.to + `?${settings.iframeQueryParams}`,
          state: item.locationState,
        }}>
          {item.label}
        </Link>
      </div>
    );
  });

  return (
    <div className="container">
      <nav className="categories d-flex justify-content-center">
        {navItems}
      </nav>
    </div>
  );
}

export default TopNav;
